import React from 'react';
import { Grid, Header } from 'semantic-ui-react';
import { DatePicker } from '../../../DatePicker';
import { InputWithoutEnter } from '../../../InputWithoutEnter';
import { TranslationComponent } from '../../../TranslationComponent';
import { useTranslation } from 'react-i18next';

interface InternalExternalComponentProps {
  internalExternal: 'internal' | 'external' | undefined;
}

export const InternalExternalComponent: React.FC<InternalExternalComponentProps> = ({ internalExternal }) => {
  const { t } = useTranslation();

  switch (internalExternal) {
    case 'internal':
      return (
        <Grid.Row>
          <Grid.Column>
            <InputWithoutEnter name={'internalEnte'} label={t('Nominativo ente interno')} />
          </Grid.Column>
        </Grid.Row>
      );
    case 'external':
      return (
        <>
          <Grid.Row>
            <Grid.Column>
              <Header size={'small'}>
                <TranslationComponent stringKey={'Numero Duvri e data:'} />
              </Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={2}>
            <Grid.Column>
              <InputWithoutEnter name={'externalDuvriNum'} label={t('Duvri n°')} />
            </Grid.Column>
            <Grid.Column>
              <DatePicker label={t('Data')} name="externalDuvriDate" />
            </Grid.Column>
          </Grid.Row>
        </>
      );
    default:
      return null;
  }
};
